<script>
  import solicitacaoTransferenciaServico from '../../servico';
  import projetoServico from '~modulos/projeto/servico';
  import converterMoeda from '~js/converter-moeda';

  export default {
    props: {
      solicitacao: {
        type: Object,
        required: true
      },
      contas: {
        type: Array,
        required: true
      },
    },
    data() {
      return {
        configuracao: this.$storage.configuracao(),
        projetoRateio: this.camposProjetoRateio(),
        projetos: [],
        metaEtapas: [],
        rubricas: [],
        subrubricas: [],        
        metaEtapa: false,
      }
    },
    methods: {
      camposProjetoRateio() {
        return {
          idProjetoCredito : '',
          valorRateio: '',
          idProjetoMetaEtapa: '',
          idRubrica: '',
          idSubRubrica: '',
          projeto: {
            idProjeto: '',
            nomeProjeto: '',
            utilizarMetaEtapaProjeto: false,
          },
          projetoMetaEtapa: {
            metaEtapa: '',
            idProjetoMetaEtapa: '',
            meta: {
              nome: ''
            },
            etapa: {
              nome: ''
            },
          },
          rubrica: {
            id: '',
            nome: '',
          },
          subrubrica: {
            id: '',
            nome: '',
          },
        }
      },
      validar() {
        this.$validator
          .validateAll()
          .then(valido => {
            if (!valido) {
              throw new Error("validacao");
            }
            else {
              this.solicitacao.solTransRateioCredito.push(this.projetoRateio);
              this.projetoRateio = this.camposProjetoRateio();
              this.limparRateio();
              this.$validator.reset();
            }
          })
          .catch(erro => {
            this.$mensagemErro(erro);
          });
      },
      validarRateioProjeto() {
        return (this.solicitacao.solTransRateioCredito.length > 0);
      },
      listaDeProjetos(idConta) {
        return solicitacaoTransferenciaServico
          .projetos(idConta, 1)
          .then(projetos => {
            this.projetos = projetos;
          });
      },
      listaDeMetaEtapas(idProjeto) {
        if (idProjeto == 0) {
          this.metaEtapas = [];
          return;
        }

        projetoServico
                .metaEtapas(idProjeto)
          .then(metaEtapas => {
            this.metaEtapas = metaEtapas;
          });
      },
      listaDeRubricas(idProjeto, idMetaEtapa) {
        if (idProjeto == 0) {
          this.rubricas = [];
          return;
        }

        return projetoServico
          .rubricasTransferencia(idProjeto, idMetaEtapa, 1)
          .then(rubricas => {
            this.rubricas = rubricas;

            if (this.rubricas.length == 1) {
                this.projetoRateio.idRubrica = this.rubricas[0].id;
                this.setarRubrica(this.rubricas[0].id);
                this.listaDeSubrubricas(this.projetoRateio.idProjetoCredito, this.projetoRateio.idRubrica, this.projetoRateio.idProjetoMetaEtapa);
            }
          });
      },
      listaDeSubrubricas(idProjeto, idRubrica, idMetaEtapa) {
        if ((idProjeto == 0) || (idRubrica == 0)) {
          this.subrubricas = [];
          return;
        }

        return projetoServico
                .subrubricasTransferencia(idProjeto, idRubrica, idMetaEtapa, 1)
          .then(subrubricas => {
              this.subrubricas = subrubricas;

                if (this.subrubricas.length == 1) {
                    this.projetoRateio.idSubRubrica = this.subrubricas[0].id;
                    this.setarSubRubrica(this.subrubricas[0].id);                        
                }
          });
      },
      setarProjeto(idProjeto) {
        this.projetos.map(projeto => {
          if (projeto.idProjeto == idProjeto) {
            this.$set(this.projetoRateio, 'projeto', projeto);
          }
        });
      },
      setarMetaEtapa(idMetaEtapa) {
        this.metaEtapas.map(metaEtapa => {
          if (metaEtapa.idProjetoMetaEtapa == idMetaEtapa) {
            this.$set(this.projetoRateio, 'projetoMetaEtapa', metaEtapa);
          }
        });
      },
      setarRubrica(idRubrica) {
        if ((this.rubricas.length == 1) && (idRubrica == 0)) 
            return;

        this.rubricas.map(rubrica => {
          if (rubrica.id == idRubrica) {
            this.$set(this.projetoRateio, 'rubrica', rubrica);
          }
        });
      },
      setarSubRubrica(idSubrubrica) {
        if ((this.subrubricas.length == 1) && (idSubrubrica == 0)) 
            return;

        this.subrubricas.map(subrubrica => {
          if (subrubrica.id == idSubrubrica) {
            this.$set(this.projetoRateio, 'subrubrica', subrubrica);
          }
        });
      },
      limparRateio() {
        this.projetoRateio = this.camposProjetoRateio();
        $('#projeto').val('0').select2();
        $('#metaEtapa').val('0').select2();
        $('#rubrica').val('0').select2();
        $('#subrubrica').val('0').select2();

        this.iniciarSelect2Projeto();
        this.iniciarMetaEtapa();
        this.iniciarRubrica();
        this.iniciarSubrubrica();

        this.rubricas = [];
        this.metaEtapas = [];
        this.subrubricas = [];
      },
      deletarProjeto(indice) {
        this.solicitacao.solTransRateioCredito.splice(indice, 1);
      },
      iniciarMetaEtapa() {
        const _this = this;

        $('#metaEtapa').select2({
          theme: "bootstrap",
          placeholder: "Selecione...",
          language: "pt-BR"
        })
        .change(function (e) {
          _this.$set(_this.projetoRateio, 'idProjetoMetaEtapa', this.value);

          _this.setarMetaEtapa(this.value);

          _this.$set(_this.projetoRateio, 'idRubrica', '');
          _this.$set(_this.projetoRateio, 'idSubRubrica', '');

          _this.listaDeRubricas(_this.projetoRateio.idProjetoCredito, this.value);
          _this.iniciarRubrica();
          _this.setarRubrica(0);

          _this.listaDeSubrubricas(_this.projetoRateio.idProjetoCredito, _this.projetoRateio.idRubrica,this.value);
          _this.iniciarSubrubrica();
          _this.setarSubRubrica(0);
        });
      },
      iniciarSubrubrica() {
        const _this = this;

        $('#subrubrica').select2({
          theme: "bootstrap",
          placeholder: "Selecione...",
          language: "pt-BR"
        })
          .change(function (e) {
            _this.$set(_this.projetoRateio, 'idSubRubrica', this.value);

            _this.setarSubRubrica(this.value);
          });
      },
      iniciarRubrica() {
        const _this = this;

        $('#rubrica').select2({
          theme: "bootstrap",
          placeholder: "Selecione...",
          language: "pt-BR"
        })
          .change(function (e) {
            _this.$set(_this.projetoRateio, 'idRubrica', this.value);

            _this.setarRubrica(this.value);

            _this.$set(_this.projetoRateio, 'idSubRubrica', '');

            _this.listaDeSubrubricas(_this.projetoRateio.idProjetoCredito, _this.projetoRateio.idRubrica, _this.projetoRateio.idProjetoMetaEtapa);
            _this.iniciarSubrubrica();
            _this.setarSubRubrica(0);
          });
      },
      iniciarSelect2Projeto() {
        const _this = this;

        $('#projeto').select2({
          theme: "bootstrap",
          placeholder: "Selecione...",
          language: "pt-BR"
        })
          .change(function (e) {
           _this.$set(_this.projetoRateio, 'idProjetoCredito', this.value);

          _this.setarProjeto(this.value);

          if (!this.value) return;

          _this.$set(_this.projetoRateio, 'idProjetoMetaEtapa', '');
          _this.$set(_this.projetoRateio, 'idRubrica', '');
          _this.$set(_this.projetoRateio, 'idSubRubrica', '');

          if (_this.projetoRateio.projeto.utilizarMetaEtapaProjeto) {
            _this.listaDeMetaEtapas(this.value);
            _this.iniciarMetaEtapa();
            _this.setarMetaEtapa(0);
          }

          _this.listaDeRubricas(_this.projetoRateio.idProjetoCredito, _this.projetoRateio.idProjetoMetaEtapa);
          _this.iniciarRubrica();
          _this.setarRubrica(0);

          _this.listaDeSubrubricas(_this.projetoRateio.idProjetoCredito, _this.projetoRateio.idRubrica, _this.projetoRateio.idProjetoMetaEtapa);
          _this.iniciarSubrubrica();
          _this.setarSubRubrica(0);
        });
      },
      iniciarSelect2Conta() {
        const _this = this;

        $('#conta').select2({
          theme: "bootstrap",
          placeholder: "Selecione...",
          language: "pt-BR"
        })
          .change(function (e) {
            _this.$set(_this.solicitacao, 'idContaCredito', this.value);
            _this.projetoRateio = _this.camposProjetoRateio();
            _this.listaDeProjetos(_this.solicitacao.idContaCredito);

            _this.limparRateio();

           _this.$validator.reset();
        });
      },
    },
    computed: {
        total: function() {
            return this.solicitacao.solTransRateioCredito.reduce((somatorio, item) => {
                const valorEstimado = this.$options.filters.formatarNumero(item.valorRateio, true);
                return somatorio + valorEstimado
            }, 0);
        },
        habilitarCampos: function() {
            if (this.configuracao.selecaoDeContaWeb)
                return !(this.solicitacao.idContaCredito !== 0);

            return false;
        }
    },
    mounted() {
      this.listaDeProjetos(this.solicitacao.idContaCredito);
      this.iniciarSelect2Conta();
      this.iniciarSelect2Projeto();      
    },
  }
</script>

<template>
    <div>

        <div class="row" v-if="configuracao.selecaoDeContaWeb">
            <div class="col-xs-12">
                <div class="form-group" :class="{'has-error': errors.has('conta')}">
                    <label class="control-label" for="conta">Conta</label>

                    <select id="conta"
                            class="form-control"
                            v-model="solicitacao.idContaCredito"
                            data-vv-name="conta"
                            :disabled="solicitacao.solTransRateioCredito.length !== 0"
                            v-validate="'required'">
                        <option value="">{{ contas.length > 0 ? 'Selecione...' : 'Selecione a conta' }}</option>
                        <option :value="conta.idConta" v-for="conta in contas">{{ conta.nomeConta }}</option>
                    </select>

                    <p class="text-danger" v-show="errors.has('conta')">{{ errors.first('conta') }}</p>
                </div>
            </div>
        </div>

        <div class="table-responsive">
            <table class="table table-hover table-pointer">
                <thead v-if="solicitacao.solTransRateioCredito.length > 0">
                    <tr>
                        <th>Projeto</th>
                        <th>Meta\Etapa</th>
                        <th>Rubrica</th>
                        <th>Subrubrica</th>
                        <th>Valor (R$)</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody v-if="solicitacao.solTransRateioCredito.length > 0">
                    <tr v-for="(rateio, index)  in solicitacao.solTransRateioCredito">
                        <td>{{ rateio.projeto.nomeProjeto }}</td>
                        <td>{{ rateio.projetoMetaEtapa ? rateio.projetoMetaEtapa.meta.nome + ' - ' + rateio.projetoMetaEtapa.etapa.nome : '---' }}</td>
                        <td>{{ rateio.rubrica.nome }}</td>
                        <td>{{ rateio.subrubrica.nome }}</td>
                        <td>{{ rateio.valorRateio }}</td>
                        <td>
                            <div class="form-group no-margins">
                                <button type="button"
                                        class="btn btn-sm btn-danger btn-delete-item"
                                        title="Excluir item"
                                        @click="deletarProjeto(index)">
                                    <i class="fa fa-trash"></i>
                                </button>
                            </div>
                        </td>
                    </tr>
                </tbody>
                <tfoot v-if="solicitacao.solTransRateioCredito.length === 0">
                    <tr>
                        <td colspan="6" class="text-center">Nenhum rateio encontrado.</td>
                    </tr>
                </tfoot>
            </table>
        </div>

        <hr class="margin-top-10">

        <div class="row">
            <div class="col-xs-12">
                <div class="form-group required" :class="{'has-error': errors.has('projeto')}">
                    <label class="control-label" for="projeto">Projeto</label>

                    <select id="projeto"
                            class="form-control"
                            v-model="projetoRateio.idProjetoCredito"
                            data-vv-name="projeto"
                            :disabled="habilitarCampos"
                            v-validate="'required'">
                        <option value="0">Selecione o projeto...</option>
                        <option :value="projeto.idProjeto"
                                v-for="(projeto, index) in projetos">
                            {{ projeto.nomeProjeto }}
                        </option>
                    </select>

                    <p class="text-danger" v-show="errors.has('projeto')">{{ errors.first('projeto') }}</p>
                </div>
            </div>

            <div class="col-xs-3" v-if="projetoRateio.projeto.utilizarMetaEtapaProjeto">
                <div class="form-group required" :class="{'has-error': errors.has('metaEtapa')}">
                    <label class="control-label" for="metaEtapa">Meta etapa</label>

                    <select class="form-control"
                            id="metaEtapa"
                            v-model="projetoRateio.idProjetoMetaEtapa"
                            data-vv-name="metaEtapa"
                            data-vv-as="meta etapa"
                            :disabled="habilitarCampos"
                            v-validate="'required'">
                        <option value="">Selecione...</option>
                        <option :value="metaEtapa.idProjetoMetaEtapa"
                                v-for="(metaEtapa, index) in metaEtapas">
                            {{ `${metaEtapa.meta.nome} - ${metaEtapa.etapa.nome}` }}
                        </option>
                    </select>

                    <p class="text-danger" v-show="errors.has('metaEtapa')">{{ errors.first('metaEtapa') }}</p>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xs-5">
                <div class="form-group required" :class="{'has-error': errors.has('rubrica')}">
                    <label class="control-label" for="rubrica">Rubrica</label>

                    <select id="rubrica"
                            class="form-control"
                            v-model="projetoRateio.idRubrica"
                            data-vv-name="rubrica"
                            :disabled="habilitarCampos"
                            v-validate="'required'">
                        <option value="0">Selecione a rubrica...</option>
                        <option :value="rubrica.id"
                                v-for="(rubrica, index) in rubricas">
                            {{ rubrica.nome }}
                        </option>
                    </select>

                    <p class="text-danger" v-show="errors.has('rubrica')">{{ errors.first('rubrica') }}</p>
                </div>
            </div>

            <div class="col-xs-5">
                <div class="form-group required" :class="{'has-error': errors.has('subrubrica')}">
                    <label class="control-label" for="subrubrica">Subrubrica</label>

                    <select id="subrubrica"
                            class="form-control"
                            v-model="projetoRateio.idSubRubrica"
                            data-vv-name="subrubrica"
                            :disabled="habilitarCampos"
                            v-validate="'required'">
                        <option value="0">Selecione a subrubrica...</option>
                        <option :value="subrubrica.id"
                                v-for="(subrubrica, index) in subrubricas">
                            {{ subrubrica.nome }}
                        </option>
                    </select>

                    <p class="text-danger" v-show="errors.has('subrubrica')">{{ errors.first('subrubrica') }}</p>
                </div>
            </div>

            <div class="form-group required col-xs-2" :class="{'has-error': errors.has('valor2')}">
                <label class="control-label" for="valor2">Valor (R$)</label>

                <input type="text"
                       class="form-control text-right"
                       id="valor2"
                       v-mascara="'moeda'"
                       v-model="projetoRateio.valorRateio"
                       data-vv-name="valor2"
                       :disabled="habilitarCampos"
                       data-vv-as="valor"
                       v-validate="'required|not_zero'">

                <p class="text-danger" v-show="errors.has('valor2')">{{ errors.first('valor2') }}</p>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-12">
                <button type="button"
                        class="btn btn-success"
                        @click="validar">
                    <i class="fa fa-plus"></i> Adicionar rateio
                </button>
            </div>
        </div>

    </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-transferencia/componentes/compartilhado/FormDadosProjetosCredito.vue